const Messages = {
    bad: 'Oof! Better luck next time.',
    ok: 'Ok song knowledge.',
    good: 'Not too shabby.',
    reallygood: 'Color me impressed.'
}

export default Messages;